import { createFormatter } from '@nfctron/nexus-core';

import { useIntl } from './IntlProvider';

/**
 * React hook that provides formatting utilities based on the current locale.
 * @returns An object containing various formatting functions for numbers, dates, currencies, etc.
 * @example
 * const format = useFormat();
 * return (
 *   <div>
 *     <p>{format.date(new Date(), 'PPP')}</p>
 *     <p>{format.number(1234.56)}</p>
 *   </div>
 * );
 */
export const useFormat = () => {
	const { languageId } = useIntl();

	return createFormatter({ languageId });
};
